import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccessControlEmployerState {
  id: any;
  name: any;
  cardReference: any;
  faceReference: any;
  props: {
    [key: string]: any;
  };
}

const initialState: AccessControlEmployerState = {
  id: '',
  name: '',
  cardReference: '',
  faceReference: '',
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const accessControlEmployerSlice = createSlice({
  name: 'accessControlEmployer',
  initialState,
  reducers: {
    setAccessControlEmployer: (state, action: PayloadAction<Partial<AccessControlEmployerState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<AccessControlEmployerState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: AccessControlEmployerState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setAccessControlEmployer, resetProps, updateField, updateProps } = accessControlEmployerSlice.actions;

export default accessControlEmployerSlice.reducer;
